export const SEEDANCE25_FAMILY = "seedance25";
export const SEEDANCE25_MODEL = "sd-2.5";
export const SEEDANCE25_PLANNING_MAX_DURATION = 30;
export const SEEDANCE25_RESOLUTION = "720p";
export const SEEDANCE25_MAX_REFERENCE_IMAGES = 50;

export const VIDEO_PROVIDER_NEWAPI_SD25 = "newapi_sd25";
export const VIDEO_PROVIDER_AKOOL_SD25 = "akool_sd25";
export const VIDEO_PROVIDER_ASTROFLOW_SD25 = "astroflow_sd25";
export const VIDEO_PROVIDER_BYTEPLUS_SD25 = "byteplus_sd25";
export const VIDEO_PROVIDER_VOLCENGINE_SD25 = "volcengine_sd25";
export const VIDEO_PROVIDER_BYTEPLUS_LAS_SD25 = "byteplus_las_sd25";
export const ASTROFLOW_SEEDANCE25_MODEL = "doubao-seedance-2-5-260628";
export const BYTEPLUS_SEEDANCE25_MODEL = "dreamina-seedance-2-5-260628";
export const DEFAULT_SEEDANCE25_PROVIDER = VIDEO_PROVIDER_VOLCENGINE_SD25;

const COMMON_RATIOS = Object.freeze([
  "16:9",
  "4:3",
  "1:1",
  "3:4",
  "9:16",
  "21:9",
]);

const PROVIDER_CATALOG = Object.freeze({
  [VIDEO_PROVIDER_NEWAPI_SD25]: Object.freeze({
    retired: true,
    id: VIDEO_PROVIDER_NEWAPI_SD25,
    family: SEEDANCE25_FAMILY,
    label: "New API 2.5",
    shortLabel: "New API",
    model: SEEDANCE25_MODEL,
    minDuration: 2,
    maxDuration: 29,
    planningMaxDuration: SEEDANCE25_PLANNING_MAX_DURATION,
    defaultDuration: 5,
    maxReferenceImages: SEEDANCE25_MAX_REFERENCE_IMAGES,
    resolutions: Object.freeze([SEEDANCE25_RESOLUTION, "480p"]),
    ratios: COMMON_RATIOS,
    modes: Object.freeze(["reference", "text2video"]),
    supportsCancel: false,
    supportsAssetIngest: false,
    supportsGenerateAudioControl: false,
    durablePolling: true,
    acceptsDataImage: true,
    requiresPublicUrl: false,
  }),
  [VIDEO_PROVIDER_AKOOL_SD25]: Object.freeze({
    retired: true,
    id: VIDEO_PROVIDER_AKOOL_SD25,
    family: SEEDANCE25_FAMILY,
    label: "AKOOL 2.5",
    shortLabel: "AKOOL",
    model: SEEDANCE25_MODEL,
    minDuration: 4,
    maxDuration: 30,
    planningMaxDuration: SEEDANCE25_PLANNING_MAX_DURATION,
    defaultDuration: 5,
    maxReferenceImages: SEEDANCE25_MAX_REFERENCE_IMAGES,
    resolutions: Object.freeze([SEEDANCE25_RESOLUTION, "480p"]),
    ratios: Object.freeze(["adaptive", ...COMMON_RATIOS]),
    modes: Object.freeze(["reference", "text2video", "img2video", "start-end"]),
    supportsCancel: false,
    supportsAssetIngest: false,
    supportsGenerateAudioControl: true,
    durablePolling: true,
    // 后端会先把 data:image 输入转存到通用 OSS，再把公网 URL 交给 AKOOL。
    acceptsDataImage: true,
    requiresPublicUrl: true,
  }),
  [VIDEO_PROVIDER_ASTROFLOW_SD25]: Object.freeze({
    retired: true,
    id: VIDEO_PROVIDER_ASTROFLOW_SD25,
    family: SEEDANCE25_FAMILY,
    label: "Astroflow 2.5",
    shortLabel: "Astroflow",
    model: ASTROFLOW_SEEDANCE25_MODEL,
    minDuration: 4,
    maxDuration: 30,
    planningMaxDuration: SEEDANCE25_PLANNING_MAX_DURATION,
    defaultDuration: 5,
    maxReferenceImages: SEEDANCE25_MAX_REFERENCE_IMAGES,
    // 720p follows the upstream default; 480p remains manually selectable.
    resolutions: Object.freeze(["720p", "480p"]),
    ratios: Object.freeze(["adaptive", ...COMMON_RATIOS]),
    modes: Object.freeze(["reference", "text2video", "img2video", "start-end"]),
    supportsCancel: false,
    supportsAssetIngest: false,
    supportsGenerateAudioControl: true,
    durablePolling: true,
    // Astroflow/ModelVerse accepts both public image URLs and data:image payloads.
    acceptsDataImage: true,
    requiresPublicUrl: false,
  }),
  [VIDEO_PROVIDER_BYTEPLUS_SD25]: Object.freeze({
    id: VIDEO_PROVIDER_BYTEPLUS_SD25,
    family: SEEDANCE25_FAMILY,
    label: "Dreamina 2.5（海外代理）",
    shortLabel: "Dreamina 2.5",
    referenceNotice: "参考素材需入海外当前库；提交时由服务端核验当前库并转换为素材 ID。",
    supportsMediaReferences: true,
    requiresHttpsReferences: true,
    model: BYTEPLUS_SEEDANCE25_MODEL,
    minDuration: 4,
    maxDuration: 30,
    planningMaxDuration: SEEDANCE25_PLANNING_MAX_DURATION,
    defaultDuration: 5,
    maxReferenceImages: SEEDANCE25_MAX_REFERENCE_IMAGES,
    resolutions: Object.freeze(["720p", "480p", "1080p"]),
    ratios: Object.freeze(["adaptive", ...COMMON_RATIOS]),
    modes: Object.freeze(["reference", "text2video", "img2video", "start-end"]),
    supportsCancel: false,
    supportsAssetIngest: true,
    supportsGenerateAudioControl: true,
    supportsWatermarkControl: true,
    durablePolling: true,
    // The browser sends source media to our server; the server resolves current-library asset IDs.
    acceptsDataImage: true,
    requiresPublicUrl: false,
  }),
  [VIDEO_PROVIDER_VOLCENGINE_SD25]: Object.freeze({
    id: VIDEO_PROVIDER_VOLCENGINE_SD25,
    family: SEEDANCE25_FAMILY,
    label: "Seedance 2.5（国内官方）",
    shortLabel: "Seedance 2.5",
    referenceNotice: "参考素材需入国内当前库；提交时由服务端核验当前库并转换为素材 ID。",
    supportsMediaReferences: true,
    requiresHttpsReferences: true,
    // The server resolves this version alias using ai.volcengine-sd25.model.
    // Never infer this provider from model alone: legacy sd-2.5 belongs to New API.
    model: SEEDANCE25_MODEL,
    minDuration: 4,
    maxDuration: 30,
    planningMaxDuration: SEEDANCE25_PLANNING_MAX_DURATION,
    defaultDuration: 5,
    maxReferenceImages: SEEDANCE25_MAX_REFERENCE_IMAGES,
    resolutions: Object.freeze(["720p", "480p", "1080p"]),
    ratios: Object.freeze(["adaptive", ...COMMON_RATIOS]),
    modes: Object.freeze(["reference", "text2video", "img2video", "start-end"]),
    supportsCancel: false,
    supportsAssetIngest: true,
    supportsGenerateAudioControl: true,
    supportsWatermarkControl: true,
    durablePolling: true,
    acceptsDataImage: true,
    requiresPublicUrl: false,
  }),
  [VIDEO_PROVIDER_BYTEPLUS_LAS_SD25]: Object.freeze({
    id: VIDEO_PROVIDER_BYTEPLUS_LAS_SD25,
    legacy: true,
    retired: true,
    family: SEEDANCE25_FAMILY,
    label: "Dreamina 2.5（历史 LAS，已停用）",
    shortLabel: "Dreamina 2.5",
    referenceNotice: "历史 LAS 线路已停用；重新生成使用海外 Dreamina 代理。",
    model: BYTEPLUS_SEEDANCE25_MODEL,
    minDuration: 4,
    maxDuration: 30,
    planningMaxDuration: SEEDANCE25_PLANNING_MAX_DURATION,
    defaultDuration: 5,
    maxReferenceImages: SEEDANCE25_MAX_REFERENCE_IMAGES,
    resolutions: Object.freeze(["720p", "480p"]),
    ratios: Object.freeze(["adaptive", ...COMMON_RATIOS]),
    modes: Object.freeze(["reference", "text2video", "img2video", "start-end"]),
    supportsCancel: false,
    supportsAssetIngest: false,
    supportsGenerateAudioControl: true,
    supportsWatermarkControl: true,
    durablePolling: true,
    // Data images are uploaded by the backend; LAS receives public URLs, never asset IDs.
    acceptsDataImage: true,
    requiresPublicUrl: true,
  }),
});

export const SEEDANCE25_PROVIDER_OPTIONS = Object.freeze(
  Object.values(PROVIDER_CATALOG).filter((provider) => !provider.legacy && !provider.retired).map((provider) => Object.freeze({
    value: provider.id,
    label: provider.label,
  })),
);

export const normalizeSeedance25Provider = (value) => {
  const provider = String(value || "").trim().toLowerCase();
  if (provider === VIDEO_PROVIDER_BYTEPLUS_LAS_SD25 || provider === "byteplus-las-sd25") {
    return VIDEO_PROVIDER_BYTEPLUS_LAS_SD25;
  }
  if (provider === VIDEO_PROVIDER_BYTEPLUS_SD25 || provider === "byteplus-sd25") {
    return VIDEO_PROVIDER_BYTEPLUS_SD25;
  }
  if (provider === VIDEO_PROVIDER_VOLCENGINE_SD25 || provider === "volcengine-sd25") {
    return VIDEO_PROVIDER_VOLCENGINE_SD25;
  }
  if (provider === VIDEO_PROVIDER_AKOOL_SD25 || provider === "akool-sd25") {
    return VIDEO_PROVIDER_AKOOL_SD25;
  }
  if (
    provider === VIDEO_PROVIDER_NEWAPI_SD25
    || provider === "newapi-sd25"
    || provider === "sd25"
    || provider === "sd-2.5"
  ) {
    return VIDEO_PROVIDER_NEWAPI_SD25;
  }
  if (
    provider === VIDEO_PROVIDER_ASTROFLOW_SD25
    || provider === "astroflow-sd25"
    || provider === "astraflow_sd25"
    || provider === "astraflow-sd25"
  ) {
    return VIDEO_PROVIDER_ASTROFLOW_SD25;
  }
  return "";
};

// Never silently move a saved provider to another account or material library.
// Submission boundaries reject retired routes; historical tasks keep their route.
export const normalizeSeedance25SubmissionProvider = (value) => {
  return normalizeSeedance25Provider(value);
};

export const assertSeedance25SubmissionProvider = (value) => {
  const provider = normalizeSeedance25Provider(value);
  if (provider && PROVIDER_CATALOG[provider]?.retired) {
    throw new Error("这条 2.5 历史线路已停止新生成，请明确选择国内 Seedance 或海外 Dreamina；原参考素材和历史结果已保留。");
  }
  return provider;
};

export const isSeedance25Provider = (value) => Boolean(normalizeSeedance25Provider(value));

export const isModelArkSeedance25Provider = (value) => (
  [VIDEO_PROVIDER_BYTEPLUS_SD25, VIDEO_PROVIDER_VOLCENGINE_SD25].includes(normalizeSeedance25Provider(value))
);

export const getSeedance25Capabilities = (provider) => {
  const normalized = normalizeSeedance25Provider(provider);
  return normalized ? PROVIDER_CATALOG[normalized] : null;
};

export const getDefaultSeedance25Capabilities = () => (
  PROVIDER_CATALOG[DEFAULT_SEEDANCE25_PROVIDER]
);

/**
 * Old saved records only stored model=sd-2.5. That legacy shape belonged to
 * New API, so model fallback is deliberately one-way and is never used when
 * an explicit (even unknown) provider is present.
 */
export const resolveSeedance25Provider = ({ provider, model, fallback = "" } = {}) => {
  const rawProvider = String(provider || "").trim();
  const exactProvider = normalizeSeedance25Provider(rawProvider);
  if (exactProvider) return exactProvider;
  if (rawProvider) return "";
  const normalizedModel = String(model || "").trim().toLowerCase();
  if (normalizedModel === BYTEPLUS_SEEDANCE25_MODEL) {
    return VIDEO_PROVIDER_BYTEPLUS_SD25;
  }
  if (normalizedModel === ASTROFLOW_SEEDANCE25_MODEL) {
    return VIDEO_PROVIDER_ASTROFLOW_SD25;
  }
  if (normalizedModel === SEEDANCE25_MODEL) {
    return VIDEO_PROVIDER_NEWAPI_SD25;
  }
  return normalizeSeedance25Provider(fallback);
};

const parseDuration = (value, fallback) => {
  const parsed = Number.parseInt(String(value ?? "").replace(/[^0-9]/g, ""), 10);
  const fallbackNumber = Number.parseInt(String(fallback ?? ""), 10);
  return Number.isFinite(parsed) ? parsed : fallbackNumber;
};

export const normalizeSeedance25Duration = (provider, value, fallback) => {
  const capabilities = getSeedance25Capabilities(provider) || getDefaultSeedance25Capabilities();
  const next = parseDuration(value, fallback);
  const resolved = Number.isFinite(next) ? next : capabilities.defaultDuration;
  return Math.max(capabilities.minDuration, Math.min(capabilities.maxDuration, resolved));
};

export const normalizeSeedance25PlanningDuration = (provider, value, fallback) => {
  const capabilities = getSeedance25Capabilities(provider) || getDefaultSeedance25Capabilities();
  const next = parseDuration(value, fallback);
  const resolved = Number.isFinite(next) ? next : capabilities.planningMaxDuration;
  return Math.max(capabilities.minDuration, Math.min(capabilities.planningMaxDuration, resolved));
};

export const normalizeSeedance25Ratio = (provider, value, fallback = "9:16") => {
  const capabilities = getSeedance25Capabilities(provider) || getDefaultSeedance25Capabilities();
  const requested = String(value || "").trim();
  if (capabilities.ratios.includes(requested)) return requested;
  const fallbackRatio = String(fallback || "").trim();
  return capabilities.ratios.includes(fallbackRatio) ? fallbackRatio : "9:16";
};

export const getSeedance25RatiosForMode = (provider, mode) => {
  const capabilities = getSeedance25Capabilities(provider) || getDefaultSeedance25Capabilities();
  return capabilities.frameRatio && (mode === "img2video" || mode === "start-end")
    ? [capabilities.frameRatio]
    : capabilities.ratios;
};

export const normalizeSeedance25RatioForMode = (provider, mode, value, fallback = "9:16") => {
  const ratios = getSeedance25RatiosForMode(provider, mode);
  return ratios.length === 1 ? ratios[0] : normalizeSeedance25Ratio(provider, value, fallback);
};

export const normalizeSeedance25Resolution = (provider, value, fallback = SEEDANCE25_RESOLUTION) => {
  const capabilities = getSeedance25Capabilities(provider) || getDefaultSeedance25Capabilities();
  const requested = String(value || "").trim().toLowerCase();
  if (capabilities.resolutions.includes(requested)) return requested;
  const fallbackResolution = String(fallback || "").trim().toLowerCase();
  return capabilities.resolutions.includes(fallbackResolution)
    ? fallbackResolution
    : capabilities.resolutions[0];
};

export const getSeedance25DurationOptions = (provider) => {
  const capabilities = getSeedance25Capabilities(provider) || getDefaultSeedance25Capabilities();
  return Array.from(
    { length: capabilities.maxDuration - capabilities.minDuration + 1 },
    (_, index) => `${index + capabilities.minDuration}s`,
  );
};

export const getSeedance25ReferenceUrl = (item) => {
  if (typeof item === "string") return item.trim();
  // The original identifies the registration in the current library. Never trust
  // a saved asset:// from another library: the server resolves the authoritative ID.
  const candidates = [item?.originalUrl, item?.originalImageUrl, item?.originalVideoUrl, item?.originalAudioUrl,
    item?.sourceUrl, item?.sourceImageUrl, item?.sourceVideoUrl, item?.sourceAudioUrl, item?.rawUrl,
    item?.url, item?.base64, item?.imageUrl, item?.image_url?.url, item?.image_url,
    item?.videoUrl, item?.audioUrl, item?.exportedVideoUrl, item?.lastResultUrl, item?.generated_image,
    item?.video_url?.url, item?.audio_url?.url];
  return candidates.find((value) => typeof value === "string" && /^(https?:\/\/|data:image\/)/i.test(value.trim()))
    || candidates.find((value) => typeof value === "string" && value.trim()) || "";
};
const firstReferenceValue = getSeedance25ReferenceUrl;

export const getSeedance25ReferenceMediaType = (item) => {
  const descriptor = `${item?.mediaType || ""} ${item?.role || ""} ${item?.type || ""} ${item?.resourceType || ""}`;
  const value = String(firstReferenceValue(item) || "").split("?")[0].split("#")[0];
  if (/(^|[\s_/-])audio([\s_/-]|$)|音频/i.test(descriptor) || /\.(mp3|wav|m4a|aac|ogg|flac)$/i.test(value)) return "audio";
  if (/(^|[\s_/-])video([\s_/-]|$)|视频/i.test(descriptor) || /\.(mp4|mov|webm|m4v|avi|mkv)$/i.test(value)) return "video";
  return "image";
};

export const supportsSeedance25MediaReferences = (provider) => Boolean(getSeedance25Capabilities(provider)?.supportsMediaReferences);

// Editor bindings use one global list. ModelArk numbers each media kind separately.
// Apply only to the outgoing prompt so saved drafts retain their original bindings.
export const normalizeSeedance25ReferencePrompt = (provider, prompt, references) => {
  if (!supportsSeedance25MediaReferences(provider)) return prompt;
  const counts = { image: 0, video: 0, audio: 0 };
  const seen = new Map();
  const bindings = (Array.isArray(references) ? references : []).map((item) => {
    const type = getSeedance25ReferenceMediaType(item);
    const key = `${type}:${String(firstReferenceValue(item) || "").trim()}`;
    if (!seen.has(key)) seen.set(key, { type, index: ++counts[type] });
    return seen.get(key);
  });
  const types = { 图片: "image", 视频: "video", 音频: "audio" };
  return String(prompt || "").replace(/@(图片|视频|音频)\s*(\d+)/g, (marker, kind, number) => {
    const binding = bindings[Number(number) - 1];
    return binding?.type === types[kind] ? `@${kind}${binding.index}` : marker;
  });
};

const isDirectImageReference = (provider, value) => {
  const capabilities = getSeedance25Capabilities(provider);
  const reference = String(value || "").trim();
  if (!capabilities || !reference || /^asset:\/\//i.test(reference)) return false;
  const cleanReference = reference.split("?")[0].split("#")[0];
  if (/\.(mp4|mov|webm|m4v|mp3|wav|m4a|aac|ogg|flac)$/i.test(cleanReference)) return false;
  if (/^https?:\/\//i.test(reference)) return !capabilities.requiresHttpsReferences || /^https:\/\//i.test(reference);
  return capabilities.acceptsDataImage && /^data:image\//i.test(reference);
};

export const isSeedance25NonImageReference = (item) => {
  const descriptor = `${item?.mediaType || ""} ${item?.role || ""} ${item?.type || ""}`;
  if (/(^|[\s_-])(video|audio)([\s_-]|$)|视频|音频/i.test(descriptor)) return true;
  const value = String(firstReferenceValue(item) || "").trim();
  if (/^data:(video|audio)\//i.test(value)) return true;
  const cleanReference = value.split("?")[0].split("#")[0];
  return /\.(mp4|mov|webm|m4v|avi|mkv|mp3|wav|m4a|aac|ogg|flac)$/i.test(cleanReference);
};

export const normalizeSeedance25ReferenceUrls = (provider, references, limit) => {
  const capabilities = getSeedance25Capabilities(provider);
  if (!capabilities) return [];
  const effectiveLimit = Number.isFinite(Number(limit))
    ? Math.max(0, Number(limit))
    : capabilities.maxReferenceImages;
  const seen = new Set();
  const normalized = [];
  for (const item of Array.isArray(references) ? references : []) {
    const value = String(firstReferenceValue(item) || "").trim();
    if (getSeedance25ReferenceMediaType(item) !== "image" || !isDirectImageReference(provider, value) || seen.has(value)) continue;
    seen.add(value);
    normalized.push(value);
    if (normalized.length >= effectiveLimit) break;
  }
  return normalized;
};

export const validateSeedance25References = (provider, references) => {
  const source = Array.isArray(references) ? references : [];
  const accepted = supportsSeedance25MediaReferences(provider)
    ? [...new Set(source.filter((item) => {
      const value = String(firstReferenceValue(item) || "").trim();
      return getSeedance25ReferenceMediaType(item) === "image"
        ? isDirectImageReference(provider, value)
        : (getSeedance25Capabilities(provider)?.requiresHttpsReferences ? /^https:\/\//i : /^https?:\/\//i).test(value);
    }).map((item) => String(firstReferenceValue(item)).trim()))]
    : normalizeSeedance25ReferenceUrls(provider, source, Number.MAX_SAFE_INTEGER);
  const acceptedSet = new Set(accepted);
  const rejected = source.filter((item) => {
    const value = String(firstReferenceValue(item) || "").trim();
    return !value || !acceptedSet.has(value);
  });
  return { accepted, rejected };
};

const getReferenceGroup = (item = {}) => {
  const descriptor = `${item?.type || ""} ${item?.role || ""} ${item?.name || ""}`;
  if (/(场景|地点|scene|location)/i.test(descriptor)) return "scene";
  if (/(道具|物件|prop|object)/i.test(descriptor)) return "prop";
  return "character";
};

export const buildSeedance25NamedReferences = (provider, references) => {
  const allowedUrls = new Set(normalizeSeedance25ReferenceUrls(provider, references));
  const groups = {
    refCharacterImages: [],
    refSceneImages: [],
    refPropImages: [],
  };
  const seen = new Set();
  (Array.isArray(references) ? references : []).forEach((item, index) => {
    const value = String(firstReferenceValue(item) || "").trim();
    if (!allowedUrls.has(value) || seen.has(value)) return;
    seen.add(value);
    const namedReference = {
      name: String(item?.name || item?.label || `参考图${index + 1}`).trim(),
      base64: value,
    };
    const group = getReferenceGroup(item);
    if (group === "scene") groups.refSceneImages.push(namedReference);
    else if (group === "prop") groups.refPropImages.push(namedReference);
    else groups.refCharacterImages.push(namedReference);
  });
  return groups;
};

export const buildSeedance25ReferencePayload = (provider, references) => {
  const capabilities = getSeedance25Capabilities(provider);
  const validation = validateSeedance25References(provider, references);
  if (validation.rejected.length) {
    throw new Error(`${getSeedance25Capabilities(provider)?.label || "即梦 2.5"} 参考素材缺少可用原始${getSeedance25Capabilities(provider)?.requiresHttpsReferences ? "公网 HTTPS" : "公网"} URL 或图片数据；请补充原始素材，不能仅使用素材库 ID`);
  }
  if (normalizeSeedance25ReferenceUrls(provider, references, Number.MAX_SAFE_INTEGER).length > capabilities.maxReferenceImages) {
    throw new Error(`${capabilities.label} 最多支持 ${capabilities.maxReferenceImages} 张参考图片，请减少后重试`);
  }
  const payload = {
    referenceUrls: normalizeSeedance25ReferenceUrls(provider, references),
    ...buildSeedance25NamedReferences(provider, references),
  };
  if (supportsSeedance25MediaReferences(provider)) {
    const source = Array.isArray(references) ? references : [];
    const seen = new Set();
    payload.guaVideoContents = source.flatMap((item) => {
      const url = String(firstReferenceValue(item) || "").trim();
      if (!url) return [];
      const mediaType = getSeedance25ReferenceMediaType(item);
      const key = `${mediaType}:${url}`;
      if (seen.has(key)) return [];
      seen.add(key);
      return [{ type: `${mediaType}_url`, url, role: `reference_${mediaType}` }];
    });
  }
  return payload;
};
